import SummaryList from './SummaryList';
import HeaderMenu from '../menu/HeaderMenu'
import FooterMenu from '../menu/FooterMenu'

const Summary = (props) => {

    return (
        <div>
            <HeaderMenu />
            <SummaryList />
            <FooterMenu />
        </div>
    );
};

export default Summary;